// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3ngua","introContainer":"Contact_introContainer__8dEFq","ensemble":"Contact_ensemble__2QWcE","spin":"Contact_spin__3Nqtd"};